// extracted by mini-css-extract-plugin
export default {"mainmenu":"MainMenu_mainmenu__7bLQr","logo":"MainMenu_logo__XUdmY","profile":"MainMenu_profile__0ZTtG"};